import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=96398300&scoped=true"
import script from "./EntityHeader.vue?vue&type=script&lang=js"
export * from "./EntityHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96398300",
  null
  
)

export default component.exports